const REDIRECT_KEY = 'postLoginRedirect'

export const savePostLoginRedirect = (path: string) => {
  try {
    sessionStorage.setItem(REDIRECT_KEY, path)
  } catch (e) {}
}

export const clearPostLoginRedirect = () => {
  try {
    sessionStorage.removeItem(REDIRECT_KEY)
  } catch (e) {}
}

export const getPostLoginRedirect = (eventcode: string) => {
  const fallback = '/' + eventcode + '/welcome/'
  let saved: string | null = null
  try {
    saved = sessionStorage.getItem(REDIRECT_KEY)
  } catch (e) {}
  clearPostLoginRedirect()

  if (saved && eventcode && saved.toLowerCase().startsWith('/' + eventcode.toLowerCase() + '/')) {
    return saved
  }
  return fallback
}
